import styles from "../../assets/scss/modules/PublicListingSingle.module.scss";
import React from 'react';
import {Accordion, AccordionDetails, AccordionSummary} from "@mui/material";
import {useSingleListing} from "../context/SingleListingProvider.tsx";
import {useWpContext} from "../context/WordPressProvider.tsx";
import {strEmpty} from "../../utils/utils.ts";
import {ExpandMore} from "@mui/icons-material";
import useCtrValeursFixes from "../../hooks/useCtrValeursFixes.ts";
import useCtrMetaFields from "../../hooks/useCtrMetaFields.tsx";
import {useFetchAdditionalLinksQuery, useFetchRenovationsQuery} from "../../store/api-rest.ts";
import {CtrDomainsVf, CtrDynamicTables, CtrRenovations} from "../../graphql/generated/graphql-main.tsx";
import useReactTexts from "../../hooks/useReactTexts.ts";

const cssroot = "xlda";

const ListingDetailAccordions = () => {
    const {others, is_fr} = useWpContext<ZListingSingle>();
    const {__} = useReactTexts();
    const {listing} = useSingleListing();
    const {fixedValue} = useCtrValeursFixes();
    const {toHtml} = useCtrMetaFields();
    const {data: renovations} = useFetchRenovationsQuery(others.mls_id);
    const {data: links} = useFetchAdditionalLinksQuery(others.mls_id);

    const addenda = () => {
        const _txt = is_fr ? listing?.ADDENDA_COMPLET_F : listing?.ADDENDA_COMPLET_A;
        return strEmpty(_txt) ? null : _txt;
    }

    return <div className={`${cssroot}__root mt-8 w-full space-y-3`}>

        {/* addenda */}
        {addenda() && (
            <Accordion className={styles.accordion}>
                <AccordionSummary expandIcon={<ExpandMore/>} className={"font-bold"} component={"div"}>
                    {__("Addenda")}
                </AccordionSummary>
                <AccordionDetails>
                    <div dangerouslySetInnerHTML={{__html: addenda() ?? "nd"}}></div>
                </AccordionDetails>
            </Accordion>
        )}

        {/* renovations */}
        {renovations?.length! > 0 && (
            <Accordion className={styles.accordion}>
                <AccordionSummary expandIcon={<ExpandMore/>} className={"font-bold"} component={"div"}>
                    {__("Rénovations")}
                </AccordionSummary>
                <AccordionDetails>
                    {renovations?.map((it: CtrRenovations, idx) => {
                        const elem = toHtml<CtrRenovations>(it, CtrDynamicTables.Renovations);

                        return <div
                            key={`reno-${it?.NO_INSCRIPTION}.${idx}`}
                            className={"mb-4"}
                        >
                            <div className={"font-bold"}>
                                {fixedValue(CtrDomainsVf.RenovationType, it?.RENOVATION_TYPE)}
                            </div>

                            <div>{elem("ANNEE", {bold: false})}</div>
                            <div>{elem("MONTANT", {bold: false, type: "currency"})}</div>
                            <div>{elem(is_fr ? "INFORMATIONS_FRANCAISES" : "INFORMATIONS_ANGLAISES", {
                                bold: false
                            })}</div>
                        </div>
                    })}
                </AccordionDetails>
            </Accordion>
        )}

        {/* additional links - todo completely hidden since all links are visible in buttons below carousel */}
        {/*{links?.length! > 0 && (*/}
        {/*    <Accordion className={styles.accordion}>*/}
        {/*        <AccordionSummary expandIcon={<ExpandMore/>} className={"font-bold"}>*/}
        {/*            {__("Liens additionnels")}*/}
        {/*        </AccordionSummary>*/}
        {/*        <AccordionDetails>*/}
        {/*            {links?.map((it: CtrLiensAdditionnels, idx) => {*/}
        {/*                const label = fixedValue(CtrDomainsVf.TypeLien, it?.TYPE_LIEN);*/}
        {/*                const link = (is_fr ? it?.LIEN_FRANCAIS : it?.LIEN_ANGLAIS) ?? "";*/}
        {/*                return <div key={`lnk-${it?.NO_INSCRIPTION}.${idx}`} className={""}>*/}
        {/*                    /!*<div className={"font-bold"}>*!/*/}
        {/*                    /!*    {label}*!/*/}
        {/*                    /!*</div>*!/*/}
        {/*                    /!* link to video, 3D MatterPort visit, etc. *!/*/}
        {/*                    <a href={link} target={"_blank"}>{label}</a>*/}
        {/*                </div>*/}
        {/*            })}*/}
        {/*        </AccordionDetails>*/}
        {/*    </Accordion>*/}
        {/*)}*/}
    </div>
};

export default ListingDetailAccordions;
